import React, { createContext } from 'react'
import propTypes from 'prop-types'

import useGetProjectUnits from 'hooks/useGetProjectUnits'
import useGetBuildings from 'hooks/useGetBuildigs'

import { CardView, ListView } from './components'

const LoadingContext = createContext(null)

const ProjectParkingsInventory = ({ viewType }) => {
  const { units, loading, refetchUnits } = useGetProjectUnits()
  const { buildings, loading: getBuildings } = useGetBuildings()

  return (
    <LoadingContext.Provider value={null}>
      {viewType === 'cardView' && (
        <CardView
          {...{ units, gettingUnits: loading, buildings, getBuildings, refetchUnits }}
        />
      )}
      {viewType === 'listView' && (
        <ListView
          {...{ units, gettingUnits: loading, buildings, getBuildings, refetchUnits }}
        />
      )}
    </LoadingContext.Provider>
  )
}

export default ProjectParkingsInventory

ProjectParkingsInventory.propTypes = {
  viewType: propTypes.string
}
